import React, {useMemo} from 'react';
import type {RightPanelConfig} from 'components/scene/types';
import {CodeListsGate} from 'services/codelists';
import {useAllCodeListIds} from 'services/codelists/hooks/useAllCodeListIds';
import {
  SceneExtensionsContext,
  useLinkedValueSearchSceneExtensionCore,
  useSceneExtensionsContextProviderValue,
} from 'sceneExtensions';
import {SearchPrizesScene} from './SearchPrizesScene';

export const PrizesScene: React.FC = () => {
  const searchConfig: Partial<RightPanelConfig> = {
    initialFullWidth: true,
    canToggleFullWidth: false,
  };

  const codelistIds = useAllCodeListIds();

  const linkedValueSearchExtension =
    useLinkedValueSearchSceneExtensionCore(searchConfig);
  const extensions = useMemo(
    () => [linkedValueSearchExtension],
    [linkedValueSearchExtension],
  );

  const sceneExtensionContext =
    useSceneExtensionsContextProviderValue(extensions);

  return (
    <CodeListsGate codeLists={codelistIds}>
      <SceneExtensionsContext.Provider value={sceneExtensionContext}>
        <SearchPrizesScene />
      </SceneExtensionsContext.Provider>
    </CodeListsGate>
  );
};
